export const USER = 'USER';
export const PERSISTED_USER = 'PERSISTED_USER';
export const FULLY_AUTHENTICATED_USER = 'FULLY_AUTHENTICATED_USER';

export const AUTHENTICATION_ROUTES = [/^\/profile\/sign-in/, /^\/profile\/register/, /^\/re-auth/];
export const PERSISTED_USER_PROTECTED_ROUTES = [/^\/profile/];
export const FULLY_AUTHENTICATED_USER_PROTECTED_ROUTES = [/^\/profile\/edit/];

export const SIGN_IN_ROUTE = '/sign-in';
export const RE_AUTH_ROUTE = '/re-auth';

export type AuthenticationLevel =
	| typeof USER
	| typeof FULLY_AUTHENTICATED_USER
	| typeof PERSISTED_USER;
